import { marker } from 'leaflet';
import { loc_equal } from 'shared/map/lib/utils';
import { useLeafletContext } from '@react-leaflet/core';
import { useEffect, useRef } from 'react';
import { DeviceIcon } from 'entities/device.map.markers/model/leaflet-marker';
import { getAngle } from 'entities/device.map.markers/lib';
/**
 * @function createIconMarker
 * Однажды был случай, что словили неверную работу связки babel & typescript
 * Нарушалась последовательность вызова constructor'a
 * Сначала вызвался createLeafletElement, записался this.icon
 * После этого вызвался constructor и инициализировал this.icon = undefined
 * @param context
 * @param props
 * @return marker
 */
function createIconMarker(context, props) {
    const { name, color, icon_size, label_visible, opacity, position, prev_position } = props;
    return new DeviceIcon({
        iconUrl: 'https://yastatic.net/www/2.1620/white/blocks/bender/desk-notif-card/_route/desk-notif-card_route_yes.assets/desk-notif-card__route-traffic-green.svg',
        iconSize: [icon_size, icon_size],
        color,
        label: name,
        label_visible,
        opacity,
        angle: getAngle(context, prev_position, position),
    });
}
function updateDeviceMarker(context, instance, props, prevProps) {
    let icon_changed = false;
    const icon = createIconMarker(context, prevProps);
    if (prevProps.icon_size !== props.icon_size) {
        icon.options.iconSize = [props.icon_size, props.icon_size];
        icon_changed = true;
    }
    if (prevProps.color !== props.color) {
        icon.options.color = props.color;
        icon_changed = true;
    }
    if (prevProps.name !== props.name) {
        icon.options.label = props.name;
        icon_changed = true;
    }
    if (prevProps.label_visible !== props.label_visible) {
        icon.options.label_visible = props.label_visible;
        icon_changed = true;
    }
    // if (prevProps.opacity !== props.opacity) {
    //     icon.options.opacity = props.opacity;
    //     icon_changed = true;
    // }
    if (!loc_equal(prevProps.prev_position, props.prev_position) ||
        !loc_equal(prevProps.position, props.position)) {
        icon.options.angle = getAngle(context, props.prev_position, props.position);
        icon_changed = true;
    }
    if (icon_changed) {
        const icon = createIconMarker(context, props);
        instance.setIcon(icon);
    }
    if (!loc_equal(prevProps.position, props.position))
        instance.setLatLng(props.position);
}
export const DeviceMarker = (props) => {
    const context = useLeafletContext();
    const elementRef = useRef();
    const propsRef = useRef(props);
    useEffect(() => {
        const icon = createIconMarker(context, props);
        const _marker = marker(props.position);
        _marker.on('click', (e) => props.onClick?.(e));
        _marker.setIcon(icon);
        elementRef.current = _marker;
        const container = context.layerContainer || context.map;
        container.addLayer(elementRef.current);
        return () => {
            if (elementRef.current)
                container.removeLayer(elementRef.current);
        };
    }, []);
    useEffect(() => {
        const container = context.layerContainer || context.map;
        if (elementRef.current) {
            updateDeviceMarker(context, elementRef.current, props, propsRef.current);
            container.addLayer(elementRef.current);
        }
        return () => {
            if (elementRef.current)
                container.removeLayer(elementRef.current);
        };
    }, [props]);
    return null;
};
